var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.33 8.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.62,5.8a3.94,3.94,0,0,1-3-1.74,3.83,3.83,0,0,1,3-1.72c1.17,0,2.18.57,2.18,1.72S14.79,5.8,13.62,5.8Zm-8.89,0c-1.14,0-2.16-.57-2.16-1.72s1-1.74,2.13-1.74a3.94,3.94,0,0,1,3,1.74A3.92,3.92,0,0,1,4.73,5.77ZM13.91,0A6.16,6.16,0,0,0,9.23,2.21,6.31,6.31,0,0,0,4.47,0C2,0,0,1.53,0,4.08s1.95,4,4.42,4A6.18,6.18,0,0,0,9.1,5.88a6.25,6.25,0,0,0,4.76,2.24c2.47,0,4.47-1.53,4.47-4.08S16.35,0,13.91,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.44cbd81085f867fcaefa62bf32bac840.svg";
export { ForwardRef as ReactComponent };